var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAiWand = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_wand)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 58L43 28L47 32L17 62L13 58Z",
    fill: "url(#paint0_linear_wand)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 12L55 19L62 22L55 25L52 32L49 25L42 22L49 19L52 12Z",
    fill: "url(#paint0_linear_wand)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 10L27 14L31 16L27 18L25 22L23 18L19 16L23 14L25 10Z",
    fill: "url(#paint0_linear_wand)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 45L71.5 48.5L75 50L71.5 51.5L70 55L68.5 51.5L65 50L68.5 48.5L70 45Z",
    fill: "url(#paint0_linear_wand)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_wand",
    x: 13,
    y: 10,
    width: 62,
    height: 55,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.61516
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.807578
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_wand"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_wand",
    x1: 64,
    y1: 84,
    x2: 3,
    y2: 74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E3DE",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#E8E3DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#E8E3DE",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E3DE"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAiWand, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ai-wand.aafa0158.svg";
export { ForwardRef as ReactComponent };